// ===== MONKEWORLD CART — Shopify Cart API Integration =====

(function () {
  'use strict';

  var config = window.MonkeWorld || {};
  var FREE_SHIPPING_THRESHOLD = config.freeShippingThreshold || 5000; // cents

  // Resolve the single-Monke variant for the free-shipping upsell.
  // Prefer explicit theme settings; otherwise scrape the hero bundle selector.
  var SINGLE_MONKE_VARIANT_ID = config.singleMonkeVariantId || null;
  var SHIP_PROTECT_VARIANT_ID = '53622514712915';
  var SHIP_PROTECT_PRICE = 199; // $1.99 in cents
  var SINGLE_MONKE_PRICE = config.singleMonkePrice || 0;
  if (!SINGLE_MONKE_VARIANT_ID || !SINGLE_MONKE_PRICE) {
    var heroSingleRadio = document.querySelector('[data-bundle-group="hero"] input[data-quantity="1"]');
    if (heroSingleRadio) {
      SINGLE_MONKE_VARIANT_ID = SINGLE_MONKE_VARIANT_ID || heroSingleRadio.dataset.variantId;
      SINGLE_MONKE_PRICE = SINGLE_MONKE_PRICE || parseInt(heroSingleRadio.dataset.price, 10) || 2999;
    }
  }
  SINGLE_MONKE_PRICE = SINGLE_MONKE_PRICE || 2999;
  // Function declarations below are hoisted, so isValidVariantId is safe here.
  var HAS_SINGLE_MONKE_VARIANT = !!SINGLE_MONKE_VARIANT_ID && isValidVariantId(SINGLE_MONKE_VARIANT_ID);

  // ===== CLIENT-SIDE RATE LIMITING =====
  var cartOpTimestamps = [];
  var CART_OP_LIMIT = 5;
  var CART_OP_WINDOW = 10000; // 10 seconds

  function isCartRateLimited() {
    var now = Date.now();
    cartOpTimestamps = cartOpTimestamps.filter(function (t) { return now - t < CART_OP_WINDOW; });
    if (cartOpTimestamps.length >= CART_OP_LIMIT) {
      return true;
    }
    cartOpTimestamps.push(now);
    return false;
  }

  // ===== INPUT VALIDATION =====
  function isValidVariantId(id) {
    return /^\d+$/.test(String(id));
  }

  function isValidQuantity(qty) {
    var n = Number(qty);
    return Number.isInteger(n) && n >= 0 && n <= 99;
  }

  // ===== DOM REFS =====
  var cartBtn = document.getElementById('cartBtn');
  var cartCount = document.getElementById('cartCount');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartClose = document.getElementById('cartClose');
  var cartItems = document.getElementById('cartItems');
  var cartEmpty = document.getElementById('cartEmpty');
  var cartFooter = document.getElementById('cartFooter');
  var cartTotal = document.getElementById('cartTotal');
  var shippingFill = document.getElementById('shippingFill');
  var shippingMsg = document.getElementById('shippingMsg');
  var cartUpsellBtn = document.getElementById('cartUpsellBtn');
  var cartUpsellPrice = document.getElementById('cartUpsellPrice');
  var stickyBar = document.getElementById('stickyBar');
  var stickyCartBtn = document.getElementById('stickyCartBtn');
  var heroSection = document.getElementById('heroSection');
  var cartLoading = document.getElementById('cartLoading');

  // ===== MONEY FORMATTING =====
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Cart state cache (used by shipping protection logic below).
  // Meta Pixel events are handled by the Meta Sales Channel Web Pixel Extension,
  // not by manual fbq calls — keeps browser + CAPI deduplication working.
  var lastCartState = null;

  // ===== BUNDLE SELECTOR SYNC =====
  function getSelectedBundle() {
    var heroGroup = document.querySelector('[data-bundle-group="hero"]');
    if (!heroGroup) return null;
    var checked = heroGroup.querySelector('input:checked');
    if (!checked) return null;
    var nameEl = checked.parentNode && checked.parentNode.querySelector('.bundle-name');
    return {
      variantId: checked.dataset.variantId,
      quantity: parseInt(checked.dataset.quantity) || 1,
      price: parseInt(checked.dataset.price) || 0,
      name: nameEl ? nameEl.textContent.trim() : ''
    };
  }

  function getSelectedVariantId() {
    var bundle = getSelectedBundle();
    return bundle ? bundle.variantId : null;
  }

  function syncBundles(selectedRadio) {
    var quantity = selectedRadio.dataset.quantity;
    document.querySelectorAll('.bundle-selector input[type="radio"]').forEach(function (radio) {
      radio.checked = radio.dataset.quantity === quantity;
    });
    var price = parseInt(selectedRadio.dataset.price) || 0;
    var compare = parseInt(selectedRadio.dataset.compare) || 0;
    updateStickyPrice(price, compare);
    updateHeroPrice(price, compare);
  }

  function updateStickyPrice(bundlePriceCents, compareCents) {
    var stickyPrice = document.getElementById('stickyBarPrice');
    if (stickyPrice) stickyPrice.textContent = formatMoney(bundlePriceCents);
    var stickyCompare = document.getElementById('stickyBarCompare');
    if (stickyCompare) {
      if (compareCents > bundlePriceCents) {
        stickyCompare.textContent = formatMoney(compareCents);
        stickyCompare.hidden = false;
      } else {
        stickyCompare.hidden = true;
      }
    }
  }

  function updateHeroPrice(bundlePriceCents, compareCents) {
    var heroCurrent = document.getElementById('heroPriceCurrent');
    if (heroCurrent) heroCurrent.textContent = formatMoney(bundlePriceCents);
    var heroCompare = document.getElementById('heroPriceCompare');
    if (heroCompare && compareCents > bundlePriceCents) heroCompare.textContent = formatMoney(compareCents);
  }

  // Listen for bundle changes
  document.querySelectorAll('.bundle-selector input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      syncBundles(e.target);
    });
  });

  // ===== SHOPIFY CART API =====
  function fetchCart() {
    return fetch(config.cartGetUrl || '/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity) {
    // Validate inputs
    if (!isValidVariantId(variantId)) {
      console.warn('Invalid variant ID:', variantId);
      return Promise.reject(new Error('Invalid variant ID'));
    }
    if (!isValidQuantity(quantity)) {
      console.warn('Invalid quantity:', quantity);
      return Promise.reject(new Error('Invalid quantity'));
    }

    // Rate limit check
    if (isCartRateLimited()) {
      console.warn('Cart rate limit exceeded. Please wait.');
      return Promise.resolve();
    }

    return fetch(config.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function changeCartItem(lineKey, quantity) {
    // Validate quantity
    if (!isValidQuantity(quantity)) {
      console.warn('Invalid quantity:', quantity);
      return Promise.reject(new Error('Invalid quantity'));
    }

    // Rate limit check
    if (isCartRateLimited()) {
      console.warn('Cart rate limit exceeded. Please wait.');
      return Promise.resolve();
    }

    return fetch(config.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  // ===== RENDER CART =====
  function renderCart(cart) {
    lastCartState = cart;
    var totalPrice = cart.total_price; // cents

    // Hide loading spinner
    if (cartLoading) cartLoading.style.display = 'none';

    // Filter out protection item for display purposes
    var visibleItems = cart.items.filter(function (item) {
      return String(item.variant_id) !== SHIP_PROTECT_VARIANT_ID;
    });
    var visibleCount = visibleItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);

    // Update count badge (only count visible items)
    if (cartCount) {
      cartCount.textContent = visibleCount;
      cartCount.classList.toggle('visible', visibleCount > 0);
    }

    // Sync shipping protection checkbox with cart state
    syncProtectionCheckbox(cart);

    if (visibleCount === 0) {
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartItems) cartItems.style.display = 'none';
      if (cartFooter) cartFooter.style.display = 'none';
      // If protection is the only thing left, remove it too
      var protectKey = getProtectionLineKey(cart);
      if (protectKey && cart.item_count > 0) {
        changeCartItem(protectKey, 0);
      }
    } else {
      if (cartEmpty) cartEmpty.style.display = 'none';
      if (cartItems) cartItems.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'block';

      if (cartItems) {
        cartItems.innerHTML = visibleItems.map(function (item) {
          var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_100x$1') : '';
          var title = escapeHtml(item.product_title);
          var variant = escapeHtml(item.variant_title || '');
          return '<div class="cart-item">' +
            '<div class="cart-item-img">' +
            (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + title + '">' : '') +
            '</div>' +
            '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + title + '</div>' +
            '<div class="cart-item-variant">' + variant + '</div>' +
            '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-qty">' +
            '<button data-line-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-line-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '</div>' +
            '</div>';
        }).join('');

        // Attach qty button events with optimistic UI
        cartItems.querySelectorAll('[data-line-key]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = this.dataset.lineKey;
            var qty = parseInt(this.dataset.qty);
            // Optimistic: immediately update the displayed quantity
            var qtyRow = this.closest('.cart-qty');
            if (qtyRow) {
              var span = qtyRow.querySelector('span');
              if (span) {
                if (qty <= 0) {
                  // Fade out the item instantly
                  var item = this.closest('.cart-item');
                  if (item) item.style.opacity = '0.3';
                } else {
                  span.textContent = qty;
                }
              }
            }
            changeCartItem(key, qty);
          });
        });
      }

      // Total
      if (cartTotal) cartTotal.textContent = formatMoney(totalPrice);

      // Show/hide shipping protection toggle
      if (shipProtectEl) shipProtectEl.style.display = 'flex';

      // Shipping progress
      if (shippingFill) {
        var progress = Math.min((totalPrice / FREE_SHIPPING_THRESHOLD) * 100, 100);
        shippingFill.style.width = progress + '%';
      }
      if (shippingMsg) {
        if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
          shippingMsg.textContent = 'You qualify for FREE shipping!';
          shippingMsg.className = 'shipping-msg free';
        } else {
          var remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalPrice);
          shippingMsg.textContent = 'Add ' + remaining + ' more for FREE shipping!';
          shippingMsg.className = 'shipping-msg';
        }
      }

      renderUpsell(cart);
    }
  }

  // ===== FREE-SHIPPING UPSELL =====
  function renderUpsell(cart) {
    if (!cartUpsellBtn) return;
    var totalPrice = cart.total_price;
    var hasItems = cart.item_count > 0;
    var underThreshold = totalPrice < FREE_SHIPPING_THRESHOLD;
    var wouldCross = (totalPrice + SINGLE_MONKE_PRICE) >= FREE_SHIPPING_THRESHOLD;
    if (hasItems && underThreshold && wouldCross && HAS_SINGLE_MONKE_VARIANT) {
      cartUpsellBtn.style.display = 'flex';
      if (cartUpsellPrice) cartUpsellPrice.textContent = '+' + formatMoney(SINGLE_MONKE_PRICE);
    } else {
      cartUpsellBtn.style.display = 'none';
    }
  }

  // ===== HTML ESCAPE =====
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // ===== CART DRAWER OPEN/CLOSE =====
  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', function () { openCart(); refreshCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Escape key closes cart
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // ===== CTA BUTTONS — ADD TO CART =====
  // Use an in-flight guard instead of debounce so the first click fires
  // immediately but subsequent clicks are ignored until the request resolves.
  var addToCartInFlight = false;
  var ctaButtons = Array.prototype.slice.call(
    document.querySelectorAll('[data-add-to-cart]')
  );
  if (stickyCartBtn) ctaButtons.push(stickyCartBtn);

  function setCtaLoading(isLoading) {
    ctaButtons.forEach(function (btn) {
      btn.disabled = isLoading;
      btn.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        if (!btn.dataset.originalLabel) {
          btn.dataset.originalLabel = btn.innerHTML;
        }
        btn.innerHTML = 'Adding…';
      } else if (btn.dataset.originalLabel) {
        btn.innerHTML = btn.dataset.originalLabel;
        delete btn.dataset.originalLabel;
      }
    });
  }

  // Shared add-to-cart flow used by both the main CTAs and the cart upsell.
  function addToCartFlow(variantId, quantity, opts) {
    if (addToCartInFlight) return;
    opts = opts || {};
    addToCartInFlight = true;
    if (opts.onStart) opts.onStart();
    if (opts.openDrawer) {
      // Show spinner + hide stale content while loading
      if (cartLoading) cartLoading.style.display = 'flex';
      if (cartItems) cartItems.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = 'none';
      if (cartFooter) cartFooter.style.display = 'none';
      openCart();
    }
    addToCart(variantId, quantity)
      .then(function () { return refreshCart(); })
      .catch(function (err) { console.warn('Add to cart failed:', err); })
      .then(function () {
        addToCartInFlight = false;
        if (opts.onEnd) opts.onEnd();
      });
  }

  function handleAddToCart() {
    var bundle = getSelectedBundle();
    if (!bundle) return;

    addToCartFlow(bundle.variantId, bundle.quantity, {
      openDrawer: true,
      onStart: function () { setCtaLoading(true); },
      onEnd: function () { setCtaLoading(false); }
    });
  }

  ctaButtons.forEach(function (btn) {
    btn.addEventListener('click', handleAddToCart);
  });

  // ===== UPSELL CLICK — "Add 1 more Monke" =====
  if (cartUpsellBtn) {
    cartUpsellBtn.addEventListener('click', function () {
      if (!HAS_SINGLE_MONKE_VARIANT) return;
      addToCartFlow(SINGLE_MONKE_VARIANT_ID, 1, {
        onStart: function () { cartUpsellBtn.disabled = true; },
        onEnd: function () { cartUpsellBtn.disabled = false; }
      });
    });
  }

  // ===== SHIPPING PROTECTION (real product variant) =====
  var shipProtectCheck = document.getElementById('shipProtectCheck');
  var shipProtectEl = document.getElementById('shipProtect');
  var shipProtectBusy = false;

  function cartHasProtection(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return String(item.variant_id) === SHIP_PROTECT_VARIANT_ID;
    });
  }

  function getProtectionLineKey(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === SHIP_PROTECT_VARIANT_ID) {
        return cart.items[i].key;
      }
    }
    return null;
  }

  // Keep checkbox in sync with cart state (without firing change event)
  function syncProtectionCheckbox(cart) {
    if (!shipProtectCheck) return;
    var shouldBeChecked = cartHasProtection(cart);
    if (shipProtectCheck.checked !== shouldBeChecked) {
      shipProtectSyncing = true;
      shipProtectCheck.checked = shouldBeChecked;
      shipProtectSyncing = false;
    }
  }
  var shipProtectSyncing = false;

  if (shipProtectCheck) {
    shipProtectCheck.addEventListener('change', function () {
      if (shipProtectBusy || shipProtectSyncing) return;
      shipProtectBusy = true;
      var wantEnabled = shipProtectCheck.checked;

      if (wantEnabled) {
        // Only add if not already in cart
        if (cartHasProtection(lastCartState)) {
          shipProtectBusy = false;
          return;
        }
        addToCart(SHIP_PROTECT_VARIANT_ID, 1)
          .then(function () { return refreshCart(); })
          .catch(function () {
            shipProtectSyncing = true;
            shipProtectCheck.checked = false;
            shipProtectSyncing = false;
          })
          .then(function () { shipProtectBusy = false; });
      } else {
        // Remove protection variant from cart
        var lineKey = getProtectionLineKey(lastCartState);
        if (lineKey) {
          changeCartItem(lineKey, 0)
            .catch(function () {
              shipProtectSyncing = true;
              shipProtectCheck.checked = true;
              shipProtectSyncing = false;
            })
            .then(function () { shipProtectBusy = false; });
        } else {
          shipProtectBusy = false;
        }
      }
    });
  }

  // ===== HONEYPOT: Inject hidden field into any forms =====
  document.querySelectorAll('form').forEach(function (form) {
    if (form.querySelector('[data-honeypot]')) return;
    var hp = document.createElement('input');
    hp.type = 'text';
    hp.name = 'website_url';
    hp.setAttribute('data-honeypot', 'true');
    hp.setAttribute('autocomplete', 'off');
    hp.setAttribute('tabindex', '-1');
    hp.style.cssText = 'position:absolute;left:-9999px;top:-9999px;opacity:0;height:0;width:0;';
    form.appendChild(hp);
    form.addEventListener('submit', function (e) {
      if (hp.value) {
        e.preventDefault();
        console.warn('Bot detected via honeypot');
      }
    });
  });

  // ===== STICKY BAR (scroll-direction aware) =====
  if (heroSection && stickyBar) {
    var lastScrollY = window.scrollY;
    var pastHero = false;
    var ticking = false;

    // Track when we've scrolled past the hero
    var heroObserver = new IntersectionObserver(
      function (entries) {
        pastHero = !entries[0].isIntersecting;
        if (!pastHero) stickyBar.classList.remove('visible');
      },
      { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
    );
    heroObserver.observe(heroSection);

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var currentY = window.scrollY;
        if (pastHero) {
          // Show when scrolling down, hide when scrolling up
          if (currentY > lastScrollY && currentY - lastScrollY > 5) {
            stickyBar.classList.add('visible');
          } else if (lastScrollY > currentY && lastScrollY - currentY > 5) {
            stickyBar.classList.remove('visible');
          }
        }
        lastScrollY = currentY;
        ticking = false;
      });
    }, { passive: true });
  }

  // ===== INIT: Load current cart state =====
  refreshCart();
})();
